import {observer} from "mobx-react";
import * as React from "react";
import {CommentDataInterface} from "../../../data/FullPostModalData";
import {CommentReply} from "./CommentReply";
import {CommentReplyAdd} from "./CommentReplyAdd";

import './CommentReplies.pcss';
import {IMentionUser} from "shared/IMentionUser";
import {INotification} from "data/entities/INotification";

interface Props {
  comment:any;
  addReply:(commentData:CommentDataInterface)=>Promise<void>;
  commentPeriodHasEnded:boolean;
  possibleUsersToMention:IMentionUser[];
  possibleRelatedNotifications:INotification[];

}

@observer
export class CommentReplies extends React.Component<Props> {

  handleAddReply = (reply:string) => {
    const commentData:CommentDataInterface = {
      comment:reply,
      parentCommentId:this.props.comment._id,
    }
    return this.props.addReply(commentData);
  }

  render(){
    const originalCommenter = this.props.comment.userId ? this.props.comment.userId.nameOrNickname : '';

    let previousRelatedNotification:INotification|null = null;
    const noReplies = !this.props.comment.replies||this.props.comment.replies.length==0;
    return (

        <div className={`comment-replies${noReplies?' no-replies':''}`}>
          {!noReplies &&
            <div aria-label={'Replies to '+originalCommenter+':'} role={'list'}>
              {this.props.comment.replies.map((reply, idx) => {
                let hideNotificationIcon = false;
                let relatedNotification:INotification|null = null;
                if(this.props.possibleRelatedNotifications) {
                  for(let possibleRelatedNotification of this.props.possibleRelatedNotifications) {
                    if(possibleRelatedNotification.referencedEntityId==reply._id) {
                      relatedNotification = possibleRelatedNotification;
                      break;
                    }
                  }
                  hideNotificationIcon = !!relatedNotification && !!previousRelatedNotification && previousRelatedNotification.type===relatedNotification.type;
                  if(!relatedNotification) {
                    previousRelatedNotification = null;
                    hideNotificationIcon = true;
                  }
                }
                // for next time
                previousRelatedNotification = relatedNotification;
                return (
                  <CommentReply
                    key={idx}
                    reply={reply}
                    relatedNotification={relatedNotification}
                    hideNotificationIcon={hideNotificationIcon}
                  />
                  );
                })
              }
            </div>
          }

          {!this.props.commentPeriodHasEnded &&
              <CommentReplyAdd addReply={this.handleAddReply} originalCommenter={originalCommenter} possibleUsersToMention={this.props.possibleUsersToMention} />
          }

        </div>
    );
  }

}
